<template>
  <a v-if="isExternal()" :href="href"><slot /></a>
  <router-link v-else :to="href"><slot /></router-link>
</template>

<script>
export default {
  name: "m-a",
  props: ["href"],
  methods: {
    gotoTop() {
      window.scroll(0, 0);
    },
    isExternal() {
      return typeof this.href === "string" && this.href.startsWith("http");
    },
  },
};
</script>

<style scoped>
a { 
  text-decoration: none;
}
</style>

